import { render, staticRenderFns } from "./ClientMailbuilderEdit.vue?vue&type=template&id=02b42216"
import script from "./ClientMailbuilderEdit.vue?vue&type=script&lang=js"
export * from "./ClientMailbuilderEdit.vue?vue&type=script&lang=js"
import style0 from "./ClientMailbuilderEdit.vue?vue&type=style&index=0&id=02b42216&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports